module.exports = __webpack_public_path__ + "static/media/encabezado_new_2023.293eb1b3.jpg";